import React from 'react'
import keyMirror from 'keymirror'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { ADMIN_ROUTES } from '../../../../constants'
dayjs.extend(utc)

export const OPTIONS_KEYS = keyMirror({
  accounts: null,
  accountsNotAssigned: null
})

export const cellTemplates = {
  /* eslint-disable-next-line jsx-a11y/anchor-is-valid */
  drilldownLink: (accessor) => ({ row }) => (
    <Link
      onClick={(event) => event.stopPropagation()}
      to={`${ADMIN_ROUTES.CLASSIFY_ASSETS}/${row.original.assetId}`}
    >
      {accessor(row.original)}
    </Link>
  )
}
export const assetCussipAccesor = (row) => row.cusip

export const MAX_CHARACTERS = 30
export const CHARACTER_SEPARATOR = ' '

export const defaultSort = [
  { id: 'longName', desc: false }
]
